import React from "react";
import Label from "../Common/Label";
import RowContainer from "../Common/RowContainer";
import Container from "../Common/Container";
import styled from "styled-components";
import dragAndDropIcon from "../../assets/Images/drag&drop.svg";
import Switch from "../Common/Switch";

interface LessonOrderRowProps {
  order: number;
  name: string;
  level: string;
  created: string;
  status: boolean;
}

const NewRowContainer = styled(RowContainer)`
  overflow: hidden;
`;

const NewLabel = styled(Label)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const LessonOrderRow: React.FC<LessonOrderRowProps> = ({
  order,
  name,
  level,
  created,
  status,
}) => {
  return (
    <Container
      bgColor="#fff"
      borderRadius="10px"
      height="50px"
      alignItems="center"
      display="flex"
      width="100%"
      className="user-data user-container-hover"
    >
      <RowContainer
        justifyContent="space-between"
        alignItem="center"
        borderRadius="12px"
        margin="10px"
        width="100%"
      >
        {/* Drag icon */}
        <RowContainer flex="1" alignItem="center">
          <img
            src={dragAndDropIcon}
            alt="Drag"
            style={{
              width: 20,
              height: 20,
              cursor: "grab",
              WebkitUserSelect: "none",
              userSelect: "none",
            }}
          />
        </RowContainer>

        <NewRowContainer flex="1" gap="0px">
          <NewLabel fontSize="16px" fontWeight={400}>
            {order}
          </NewLabel>
        </NewRowContainer>
        <NewRowContainer flex="11" gap="0px">
          <NewLabel fontSize="16px" fontWeight={400}>
            {name}
          </NewLabel>
        </NewRowContainer>

        <NewRowContainer flex="3" gap="0px">
          <NewLabel fontSize="16px" fontWeight={400}>
            {level}
          </NewLabel>
        </NewRowContainer>

        <NewRowContainer flex="5" gap="0px">
          <NewLabel fontSize="16px" fontWeight={400}>
            {created}
          </NewLabel>
        </NewRowContainer>

        <RowContainer flex="2.5" alignItem="center">
          <Switch 
            isOn={status} 
            onToggle={() => {}} 
            style={{ pointerEvents: 'none', opacity: 1 }}
          />
        </RowContainer>
      </RowContainer>
    </Container>
  );
};

export default LessonOrderRow;
